export {getContextInfo, getGLContextInfo, getContextLimits} from './limits';
export {FEATURES} from './webgl-features-table';
export {hasFeature, hasFeatures, getFeatures} from './features';

export {default as canCompileGLGSExtension} from './check-glsl-extension';
